import { createTheme } from '@mui/material/styles';
import { green, purple } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#802dc8',
    },
    secondary: {
      main: '#ff4f58',
    },
  },
});